import axios from 'axios';
import { API_BASE } from './config';

/**
 * Retrieve a wallet's private key from the server using the public address
 * @param publicAddress The wallet's public address
 * @returns The private key for the wallet
 */
export const getPrivateKeyByAddress = async (publicAddress: string) => {
  try {
    console.log('API call: getPrivateKeyByAddress for address:', publicAddress);

    const response = await axios.post(`${API_BASE}/wallet/wallet/private-key`, {
      public_address: publicAddress
    });

    console.log('API response status:', response.status);
    console.log('API response structure:', {
      hasData: !!response.data,
      status: response.data?.status,
      hasDataProperty: !!response.data?.data,
      dataKeys: response.data?.data ? Object.keys(response.data.data) : []
    });

    // Check for different response formats
    if (response.data && response.data.status === true) {
      if (response.data.data && response.data.data.privateKey) {
        console.log('Found privateKey in response.data.data');
        return response.data.data.privateKey;
      } else if (response.data.privateKey) {
        console.log('Found privateKey directly in response.data');
        return response.data.privateKey;
      } else if (response.data.data && typeof response.data.data === 'string') {
        console.log('Found string data in response.data.data');
        return response.data.data;
      }
    }

    console.log('Private key not found in response structure');
    throw new Error('Private key not found in response');
  } catch (error) {
    console.error('Error in getPrivateKeyByAddress:', error);
    if (axios.isAxiosError(error) && error.response) {
      console.error('API error response:', error.response.data);
      throw new Error(error.response.data?.error?.message || 'Failed to retrieve private key');
    }
    throw error;
  }
};
